import "../assets/styles/not-found.css";

const NotFound = () => {
  return <div className="bodyNotFound"></div>;
};

export default NotFound;
